export default function currentCateg(key) {
  //console.log(key);
  return { type: "CURRENT_CATEG", payload: key };
}
